export default __webpack_public_path__ + "static/media/first-login.c2edd6a5.svg";